import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
  updateDoc
} from "firebase/firestore";
import { db } from "../firebase";

const boardsRef = (tenantId) =>
  collection(db, "tenants", tenantId, "monthlyProcessBoards");

const processesRef = (tenantId) =>
  collection(db, "tenants", tenantId, "monthlyProcesses");

const sortByCreatedAt = (items) => [...items].sort((left, right) => {
  const leftOrder = Number(left.order);
  const rightOrder = Number(right.order);
  if (Number.isFinite(leftOrder) && Number.isFinite(rightOrder) && leftOrder !== rightOrder) {
    return leftOrder - rightOrder;
  }
  const leftTime = left.createdAt?.toMillis?.() || 0;
  const rightTime = right.createdAt?.toMillis?.() || 0;
  return leftTime - rightTime;
});

export const subscribeTenantMonthlyProcessBoards = ({ tenantId, onData, onError }) =>
  onSnapshot(
    boardsRef(tenantId),
    (snapshot) => onData(sortByCreatedAt(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })))),
    onError
  );

export const subscribeTenantMonthlyProcesses = ({ tenantId, onData, onError }) =>
  onSnapshot(
    processesRef(tenantId),
    (snapshot) => onData(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
    onError
  );

export const createTenantMonthlyProcessBoard = async ({
  tenantId,
  technoparkName,
  technoparkShortName,
  user
}) =>
  addDoc(boardsRef(tenantId), {
    tenantId,
    technoparkName: String(technoparkName || "").trim(),
    technoparkShortName: String(technoparkShortName || "").trim(),
    isActive: true,
    order: Date.now(),
    createdBy: user.uid,
    createdByEmail: user.email || "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });

export const updateTenantMonthlyProcessBoard = ({ tenantId, boardId, data }) =>
  updateDoc(doc(db, "tenants", tenantId, "monthlyProcessBoards", boardId), {
    ...data,
    updatedAt: serverTimestamp()
  });

export const createTenantMonthlyProcess = async ({
  tenantId,
  board,
  month,
  status,
  form,
  user
}) => addDoc(processesRef(tenantId), {
  tenantId,
  boardId: board.id,
  processProjectId: board.id,
  technoparkName: board.technoparkName,
  month,
  status,
  title: String(form.title || "").trim(),
  companyName: String(form.companyName || "").trim(),
  assigneeName: String(form.assigneeName || "").trim(),
  dueDate: String(form.dueDate || "").trim(),
  priority: String(form.priority || "normal"),
  description: String(form.description || "").trim(),
  createdBy: user.uid,
  createdByEmail: user.email || "",
  createdAt: serverTimestamp(),
  updatedAt: serverTimestamp()
});

export const updateTenantMonthlyProcessStatus = ({ tenantId, processId, status, user }) =>
  updateDoc(doc(db, "tenants", tenantId, "monthlyProcesses", processId), {
    status,
    updatedBy: user.email || "",
    updatedAt: serverTimestamp()
  });
